(function () {
  "use strict";

  FooterCtrl.$inject = ['$scope', 'feedbackResource', 'trackingService', '$timeout', '$rootScope'];
  angular
    .module('trainerWebApp.controllers')
    .controller('FooterCtrl', FooterCtrl);

  function FooterCtrl($scope, feedbackResource, trackingService, $timeout, $rootScope) {

    $scope.viewEnabled = true;
    $rootScope.$watch('enableNormalNav', function() {
      $scope.viewEnabled = $rootScope.enableNormalNav;
    });    

    $scope.feedbackInFocus = false;
    $scope.sendingFeedback = false;
    $scope.showThankYou = false;
    $scope.feedbackLengthValid = true;
    $scope['feedbackButtonStyle'] = 'disabled';
    $scope['feedbackButtonDisabled'] = 'disabled';

    $scope.submitFeedback = function () {
      if (!$scope.feedbackText && $scope.feedbackText.length == 0)
        return;

      $scope.sendingFeedback = true;

      feedbackResource.send($scope.feedbackText,
        "TrainerWeb",
        onSent
      );

      trackingService.trackEvent(
        trackingService.pages.trainerWeb.name,
        trackingService.pages.trainerWeb.actions.sendFeedback);
    };

    $scope.showExpanded = function () {
      return $scope.feedbackInFocus || $scope.sendingFeedback;
    };

    $scope.showSubmitButton = function () {
      return $scope.showExpanded() && !$scope.showThankYou;
    };

    function onSent() {
      $scope.feedbackText = '';
      $scope.showThankYou = true;
      $timeout(function () {
        $scope.showThankYou = false;
      }, 5000);
      $scope.sendingFeedback = false;
    }

    $scope.validateFeedbackTextLength = function () {
      var disable = $scope.feedbackText.length == 0;
      $scope['feedbackButtonStyle'] = disable ? 'disabled' : '';
      $scope['feedbackButtonDisabled'] = disable ? 'disabled' : '';
    };
  }

})();
